<template>
  <div>


  <div style="position: relative;">

    <v-responsive :aspect-ratio="16/9" class="black" style="margin-top:88px;" v-if="$vuetify.breakpoint.xsOnly">
      <div style="position: relative; height: 100%; width: 100%;">
        <v-img style=""
               :src="require('@/assets/laserbeam.jpg')"
               aspect-ratio="16/9"
               alt="LISA"
               height="100%"
        ></v-img>
      </div>
    </v-responsive>

<div  v-if="videoHeight != 0 && $vuetify.breakpoint.smAndUp" style=" width: 100%; border-bottom: 3px solid #ED1848; " :style="$vuetify.breakpoint.smAndDown ? 'margin-top:88px;' : ''" >
    <v-responsive :aspect-ratio="16/9" class="black" :max-height="500">
      <div style="position: relative; height: 100%; width: 100%;">
      <video playsinline="playsinline" autoplay="" muted="" loop="" class="fill">
        <source class="" src="LisaWEB-BG.mp4" type="video/mp4">
      </video>
      </div>
    </v-responsive>
</div>

    <v-responsive :aspect-ratio="16/9"  style="position: absolute; top:0; left:0; right:0;" :max-height="500">
      <v-container class="hidden-xs-only pb-0" flex grid-list-lg>

        <v-layout
          wrap

        >

          <v-flex xs12 md5 xl4 offset-md1 offset-xl2>
            <img src="LISA_logo.svg" class="hidden-sm-and-down" width="200">

          </v-flex>

          <v-flex xs12 md5 xl4>

            <div>
              <div :class="{'showBackground': learnMore}" style="padding: 12px;" :style="$vuetify.breakpoint.smAndDown ? 'margin-right: -12px; margin-top: 12px;' : 'margin:-12px;'">
              <p class="text-xs-right"><v-btn class="ml-0 mt-1 mb-1" dark outline="" color="grey lighten-3" @click="learnMore=!learnMore"><span v-if="learnMore===false">Learn More</span><span v-else>Close</span></v-btn></p>
               <v-expansion-panel expand class="elevation-0" style="margin-top:-52px!important;">
                <v-expansion-panel-content style="background: transparent !important; color: #eee !important;"
                  v-model="learnMore"
                >
                  <div class="headline" style="color: #eee !important;">Gravity talks &ndash; LISA listens</div>
                  <div class="body-2 pa-1 mt-2">LISA will be the first observatory in space to explore the Gravitational Universe. It will gather revolutionary information about the dark universe. It can be thought of as a high precision Michelson interferometer in space with an arm length of 2.5 mil­lion km. The arm length has been carefully chosen to allow observation of most of the interesting sources of gravitational waves in the target frequency band. LISA will enable us to discover the parts of the universe that are invisible by other means, such as black holes, the Big Bang, and other, as yet unknown, objects.</div>

                </v-expansion-panel-content>
              </v-expansion-panel>
              </div>

            </div>
          </v-flex>

        </v-layout>
      </v-container>
    </v-responsive>
    <div  style="position: absolute; bottom:0; left:0; right:0;">
      <v-container class="pb-0" flex grid-list-lg>

<v-layout>
          <v-flex xs12 md10 xl8 offset-md1 offset-xl2 >
            <v-toolbar class="elevation-0"
              style="background: transparent !important;"
            >
              <div  style="margin-left:-24px; color: rgba(255,255,255,.5);" class="caption hidden-xs-only">Credit: AEI/Milde Marketing</div>
            <v-spacer ></v-spacer>
            <v-toolbar-items style="margin-right:-24px;margin-left:-24px;margin-bottom:8px;">
              <v-btn flat style="width:115px;"><v-img style="min-height: 100%;" class="ml-3 mr-3"
                                                     :src="require('@/assets/esa.svg')"
                                                     aspect-ratio="2.5333333333333333333333333333333"
                                                     alt="ESA"
                                                     height="100%"
              ></v-img></v-btn>
              <v-btn flat style="width:80px;"><v-img style="min-height: 100%;" class="ml-3 mr-3"
                                                     :src="require('@/assets/nasa.svg')"
                                                     aspect-ratio="1"
                                                     alt="NASA"
                                                     height="100%"
              ></v-img></v-btn>
            </v-toolbar-items>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      videoHeight: 500,
      learnMore: false
    }
  },
  computed: {
    ...mapGetters({
      tabVersion: 'version/tabVersion'
    })
  },
  methods: {
    ...mapActions({
      updateTabVersion: 'version/updateTabVersion'
    })

  }

}
</script>

<style>
.fill {
  position: absolute;
  top: 50%;
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
  .showBackground {
    background: rgba(0, 0, 0, .5) !important;
  }

</style>
